import { BaseText, ListItem, Spinner, theme } from 'aimo-ui';
import Icon from 'components/icons/Icon';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components/native';
import { PaymentOption, PaymentType } from 'types/generatedSchemaTypes';
import { getPaymentMethodText } from 'utils/paymentUtils';
import { testIdentifiers } from 'utils/testIdentifiers';
import { useUiStore } from 'stores/uiStore';

export const TitleWrapper = styled.View`
  flex-direction: row;
`;

const TitleCheckWrapper = styled.View`
  margin-right: 4px;
  margin-left: 5px;
  justify-content: center;
`;

const IconComponent = () => <Icon size="l" name={'Mobile-Pay'} />;
const ArrowComponent = () => (
  <Icon name="Chevron_Right" size="s" color="black" />
);

const TitleComponent: React.FC<{
  item: PaymentOption;
  indexValue: number;
}> = ({ item, indexValue }) => {
  const { t } = useTranslation();

  return (
    <TitleWrapper>
      <BaseText
        testID={`wallet-token-title-${item.optionId}`}
        numberOfLines={1}>
        {getPaymentMethodText(item.method as PaymentType, t)}
      </BaseText>
      {item.isDefaultTokenizedPaymentOption && (
        <TitleCheckWrapper>
          <Icon
            name="check"
            size="xs"
            {...testIdentifiers(`wallet-token-is-default-${item.optionId}`)}
            color={theme.colors.black}
          />
        </TitleCheckWrapper>
      )}
    </TitleWrapper>
  );
};

const SpinnerComponent = () => <Spinner small={true} />;

const VerifyingWrapper = styled.View`
  opacity: 0.5;
`;

const WalletTokenItem = ({
  item,
  indexValue,
}: {
  item: PaymentOption;
  indexValue: number;
}) => {
  const isLoading = item.optionId === 'mobilepay-verifying';

  const content = (
    <ListItem
      item={item}
      indexValue={indexValue}
      onPress={
        isLoading
          ? undefined
          : () => useUiStore.getState().setSheetModal('walletTokenEdit')
      }
      iconComponent={IconComponent}
      titleComponent={() => TitleComponent({ item, indexValue })}
      testID={`wallet-token-item-${indexValue}`}
      rightContentComponent={isLoading ? SpinnerComponent : ArrowComponent}
    />
  );

  return isLoading ? <VerifyingWrapper>{content}</VerifyingWrapper> : content;
};

export default WalletTokenItem;
